import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from '../environments/environment';

import { GlobalCfgService } from './globalcfg.service';

@Injectable()
export class SubscriptionService {

    constructor(
        private http: HttpClient,
        private globalCfgService: GlobalCfgService
    ) {}

    getCurrentPlanOfOrg(filter) {
        return this.http.get(
            environment.apiurl +
            "/Billings?filter=" + JSON.stringify(filter) +
            "&access_token=" + this.globalCfgService.getAccessToken()
        );
    }

    getPricePlanDetails(planId) {
        return this.http.get(
            environment.apiurl +
            "/PricePlans/" + planId +
            "?access_token=" + this.globalCfgService.getAccessToken()
        );
    }

    getCurrentOrgData(filter) {
        return this.http.get(
            environment.apiurl +
            "/Organisations?filter=" + JSON.stringify(filter) +
            "&access_token=" + this.globalCfgService.getAccessToken()
        );
    }
}